// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosPromise } from 'axios';

import { authGet, authPost, parseCamelCase, parseSnakeCase } from './util';
import { Chapter, Progress, ILTCourse } from '../types/Model';
const baseURL = '/course';

export const getIltCourseData = (id: number): AxiosPromise => {
  return authGet(`${baseURL}/iltCourses/${id}/information`, {
    transformResponse: (iltCourse: ILTCourse) => parseCamelCase(iltCourse)
  });
};

interface IltCourseChapters {
  chapters: Chapter[];
  progress: Progress[];
}

export const getIltCourseContentsData = (id: number): AxiosPromise<IltCourseChapters> => {
  function parseQuiz(module: any) {
    if (module.type === 'quiz') {
      const answers = module.questions.map((question: any) =>
        question.options.reduce(
          (pre: string, cur: any, index: number) =>
            pre + (cur.answer ? String.fromCharCode(index + 65) : ''),
          ''
        )
      );
      const examData = module.questions.map((question: any) => ({
        title: question.description,
        options: question.options.map((option: any) => option.content)
      }));
      const explains = module.questions.map((question: any) => {
        return question.options.reduce(
          (pre: object, cur: any, index: number) => {
            if (cur.explain) {
              return {
                ...pre,
                [String.fromCharCode(index + 65)]: cur.explain
              };
            }
            return pre;
          },
          {}
        );
      });

      return {
        answers,
        examData,
        explains
      };
    }

    return {
      answers: [],
      examData: [],
      explains: []
    };
  }

  return authGet(`${baseURL}/iltCourses/${id}/contents`, {
    transformResponse: (data: any) => {
      if (typeof data === 'string') {
        throw data;
      }

      const {
        chapters,
        ...iltCourse
      } = parseCamelCase(data);
      const parsed = {
        ...iltCourse,
        chapters: chapters.map(
          ({ modules, ...chapter }: any, index: number) => ({
            id: index + 1,
            ...chapter,
            modules: modules.map((module: any) => ({
              ...module,
              videoUrl: module.videoUrls && module.videoUrls.hlsGroup.find((hls: any) => hls.type === 'Auto').url,
              ...parseQuiz(module)
            }))
          })
        ),
      };

      return parsed;
    }
  });
};

interface UpdateProgress {
  revisedTime: Date;
  progress: Progress[];
}

interface UpdateAttend {
  type: String;
}

export const updateIltCourseProgress = (id: number, progress: Progress): AxiosPromise<UpdateProgress> => {
  return authPost(`${baseURL}/iltCourses/${id}/progress`, parseSnakeCase(progress), {
    transformResponse: (data: any) => parseCamelCase(data)
  })
}

export const getIltCourseAttendRecord = (id:number) => {
  return authGet(`${baseURL}/iltCourses/${id}/attendRecord`, { transformResponse: (data: any) => parseCamelCase(data) });
}

export const updateIltCourseAttend = (id: number, type: UpdateAttend) => {
  return authPost(`${baseURL}/iltCourses/${id}/attend`, parseSnakeCase(type), {
    transformResponse: (data: any) => parseCamelCase(data)
  })
}
